function isDevelopmentEnvironment(): boolean {
  const developmentEnvironment = process.env.NODE_ENV === 'development';
  let debugEnvironment = false;
  if (typeof document !== 'undefined') {
    debugEnvironment = document.body.classList.contains('environment-debug');
  }
  return debugEnvironment || developmentEnvironment;
}

export default isDevelopmentEnvironment;
